import { render, staticRenderFns } from "./listaAdaptaciones.vue?vue&type=template&id=46bdceda"
import script from "./listaAdaptaciones.vue?vue&type=script&lang=js"
export * from "./listaAdaptaciones.vue?vue&type=script&lang=js"
import style0 from "./listaAdaptaciones.vue?vue&type=style&index=0&id=46bdceda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports